import React from 'react';
import { Link } from 'react-router-dom';

const Boz = () => {
  const [open, setOpen] = React.useState(false);
  return ( //ref={this.myRef}
    <div data-section-name="boz" className="fifthSlide" id="boz">
      <div className={["section snap project overlap animate boz", open ? "open" : null].join(" ")}>
        <div className="image-right">
        </div>
        <div className="projecttext">
          <div className="projectmarquee">
            <div className="menu__item">
             <a href="boz" className="menu__item-link" 
              onMouseEnter={() => { setOpen(!open);}} onMouseLeave={() => { setOpen(!open);}}>
             Brommer<br />op zee</a>
              <div className="marquee">
                <div className="marquee__inner" aria-hidden="true">
                  <span>Brommer<br />op zee</span>
                  <span>Brommer<br />op zee</span>
                  <span>Brommer<br />op zee</span>
                  <span>Brommer<br />op zee</span>
                </div>
              </div>
            </div>
          </div>
          <div className="description side">
            <h4>community bookclub app</h4>
            <h5>user experience design &amp; visual design</h5>
          </div>
        </div>
        <div className="image-right small">
        </div>
      </div>
    </div>
  );
};

export default Boz;